const getCreatedTimeValue = (createdTime) => {
    if (!createdTime) {
        return Number.NEGATIVE_INFINITY;
    }

    const timestamp = Date.parse(createdTime.replace(" ", "T"));
    return Number.isNaN(timestamp) ? Number.NEGATIVE_INFINITY : timestamp;
};

export const sortFacebookFormsByCreatedTime = (forms = []) =>
    [...forms].sort((firstForm, secondForm) => {
        const firstTime = getCreatedTimeValue(firstForm.created_time);
        const secondTime = getCreatedTimeValue(secondForm.created_time);

        if (firstTime === secondTime) {
            return 0;
        }

        return secondTime - firstTime;
    });

export const normalizeFacebookPages = (pages = []) =>
    pages.map((page) => ({
        ...page,
        page_forms: sortFacebookFormsByCreatedTime(page.page_forms ?? []).map(
            (form) => ({
                ...form,
                parentId: form.parent_id ?? page.id,
            }),
        ),
    }));

export const buildFacebookSelectedPages = ({
    pages = [],
    selectedPageIds = [],
    selectedFormIds = [],
    includeAllForms = false,
    checkNewForm = false,
}) =>
    pages
        .filter((page) => selectedPageIds.includes(page.id))
        .map((page) => {
            const selectedForms = (page.page_forms ?? [])
                .filter(
                    (form) =>
                        includeAllForms || selectedFormIds.includes(form.id),
                )
                .map((form) => form.id);

            return {
                page_id: page.id,
                selected_forms: selectedForms,
                check_new_form: checkNewForm ? 1 : 0,
            };
        })
        .filter((page) => page.selected_forms.length > 0);

export const remapFacebookPageAndFormSelections = ({
    previousPages = [],
    nextPages = [],
    selectedPageIds = [],
    selectedFormIds = [],
}) => {
    const previousPagesById = new Map(
        previousPages.map((page) => [page.id, page]),
    );
    const nextPagesByName = new Map(
        nextPages.map((page) => [page.page_name, page]),
    );

    const remappedPageIds = [];
    const remappedFormIds = [];

    selectedPageIds.forEach((pageId) => {
        const previousPage = previousPagesById.get(pageId);
        if (!previousPage) {
            return;
        }

        const nextPage = nextPagesByName.get(previousPage.page_name);
        if (!nextPage) {
            return;
        }

        remappedPageIds.push(nextPage.id);

        const previousFormsById = new Map(
            (previousPage.page_forms ?? []).map((form) => [form.id, form]),
        );
        const nextFormsByName = new Map(
            (nextPage.page_forms ?? []).map((form) => [form.name, form]),
        );

        selectedFormIds.forEach((formId) => {
            const previousForm = previousFormsById.get(formId);
            if (!previousForm) {
                return;
            }

            const nextForm = nextFormsByName.get(previousForm.name);
            if (nextForm) {
                remappedFormIds.push(nextForm.id);
            }
        });
    });

    return {
        selectedPageIds: remappedPageIds,
        selectedFormIds: remappedFormIds,
    };
};
